export const getSocialMediaFingerPrint = async () => {
    
    const createCanvasContext = () => {
        const canvas = document.createElement("canvas");
        return canvas.getContext("2d");
    };

    const getWebGLInfo = (() => {
        let cachedWebGLInfo = null;
        return () => {
            if (cachedWebGLInfo !== null) return cachedWebGLInfo;
            try {
                const canvas = document.createElement('canvas');
                const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
                if (!gl) return 'webgl-not-supported';
                    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
                    cachedWebGLInfo = debugInfo ? `${gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)}|${gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)}` : 'webgl-supported-no-debug';
                    return cachedWebGLInfo;
            } catch {
                return 'webgl-error';
            }
        };
    })();

    const getCanvasFingerprint = () => {
        try {
            const ctx = createCanvasContext();
            ctx.textBaseline = "top";
            ctx.font = "16px Arial";
            ctx.fillStyle = "#f00";
            ctx.fillRect(10, 10, 100, 50);
            ctx.fillStyle = "#00f";
            ctx.fillText("Fingerprinting!", 12, 30);
            return ctx.getImageData(0, 0, 150, 75).data.toString();
        } catch {
            return 'canvas-error';
        }
    };

    const getAudioFingerprint = async () => {
        try {
            return (new (window.AudioContext || window.webkitAudioContext)()).baseLatency.toString();
        } catch {
            return 'audio-error';
        }
    };

    const getFontFingerprint = () => {
        try {
            const ctx = createCanvasContext();
            ctx.font = "72px sans-serif";
            ctx.fillText("Hello", 10, 50);
            return ctx.measureText("Hello").width.toString();
        } catch {
            return 'font-error';
        }
    };

    const getBatteryFingerprint = async () => {
        try {
            const battery = navigator.getBattery ? await navigator.getBattery() : null;
            return battery ? `${battery.charging ? 'charging' : 'not-charging'}|${battery.level}` : 'battery-unsupported';
        } catch {
            return 'battery-error';
        }
    };

    const getMediaDevicesFingerprint = async () => {
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            return JSON.stringify(devices.reduce((acc, { kind }) => ({ ...acc, [kind]: (acc[kind] || 0) + 1 }), {}));
        } catch {
            return 'media-error';
        }
    };

    const getStableFingerprint = async () => {
        const cachedFingerprint = localStorage.getItem("device_finger_print");
        if (cachedFingerprint) return cachedFingerprint;

        const { userAgent, platform, hardwareConcurrency = 0, deviceMemory = 0 } = navigator;
        const { width: screenWidth, height: screenHeight, colorDepth } = window.screen;

        const [
            audioFingerprint, 
            batteryFingerprint, 
            mediaDevicesFingerprint
        ] = await Promise.all([
            getAudioFingerprint(),
            getBatteryFingerprint(),
            getMediaDevicesFingerprint()
        ]);

        const fingerprintData = [
            userAgent.trim().toLowerCase(),
            platform.trim().toLowerCase(),
            hardwareConcurrency,
            deviceMemory,
            screenWidth, screenHeight, colorDepth,
            getWebGLInfo(),
            getCanvasFingerprint(),
            audioFingerprint,
            getFontFingerprint(),
            Intl.DateTimeFormat().resolvedOptions().timeZone,
            navigator.language.trim().toLowerCase(),
            'ontouchstart' in window ? 'touch' : 'no-touch',
            batteryFingerprint,
            mediaDevicesFingerprint
        ].join('|');

        const hashBuffer = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(fingerprintData));
        const hashHex = Array.from(new Uint8Array(hashBuffer))
          .map(byte => byte.toString(16).padStart(2, '0'))
          .join('');

        localStorage.setItem("device_finger_print", hashHex);
        return hashHex;
    };

    return getStableFingerprint();

};
